<div
  class="modal-header bg-head py-2 d-flex justify-content-between align-items-center"
>
  <h6 class="modal-title mb-0">Change Subject Display Order</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>

<div class="row">
  <div class="col-12 headersize py-2">
    <span class="px-4 my-2 path-class">{{ path }}</span>
  </div>
</div>

<hr class="mt-0" />

<div class="modal-body m-body pt-0 px-0 scroll-area" cdkScrollable #scrollArea>
  <div class="p-4">

    <div *ngFor="let group of groupedStudyUnits" class="mb-4">

      <h6 class="fw-bold mb-2">
        {{ group.majorTopicName }}
      </h6>

      <table class="table table-fixed">
        <thead>
          <tr>
            <th class="text-center" style="width: 8%">StudyUnit ID</th>
            <th class="text-center" style="width: 40%">Topic</th>
            <th class="text-center" style="width: 40%">Study Unit Name</th>
            <th class="text-center" style="width: 7%">Study Unit Status</th>
            <th class="text-center" style="width: 5%">Display Order</th>
          </tr>
        </thead>

        <tbody
          class="example-list"
          cdkDropList
          [cdkDropListData]="group.formArray"
          (cdkDropListDropped)="drop($event, group.formArray)"
        >
          <tr
            *ngFor="let item of group.formArray.controls; let i = index"
            [formGroup]="$any(item)"
            cdkDrag
            class="example-box"
          >
            <td>
              <div class="custom-input text-end">
                {{ item.value.studyUnitId }}
              </div>
            </td>

            <td>
              <div
                class="custom-input-wrap text-start"
                [title]="item.value.topic"
              >
                {{ item.value.topic }}
              </div>
            </td>

            <td>
              <div
                class="custom-input-wrap text-start"
                [title]="item.value.studyUnitName"
              >
                {{ item.value.studyUnitName }}
              </div>
            </td>

            <td>
              <div class="custom-input text-center px-1">
                {{ item.value.studyUnitStatus }}
              </div>
            </td>

            <td>
              <div class="custom-input text-center px-1 fw-semibold">
                {{ item.value.displayOrder }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>


<div class="modal-footer d-flex justify-content-end gap-2">
  <button type="button" class="bl-btn btn btn-sm px-3" (click)="onSave()">
    Save
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border px-3"
    (click)="onCross()"
  >
    Cancel
  </button>
</div>
